import { isValidPhoneNumberFormat } from 'src/helpers'
import * as yup from 'yup'

const createGuestCardSchema = yup.object({
  lead_source_id: yup.string().required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  middleName: yup.string(),
  namePrefix: yup.string(),
  nameSuffix: yup.string(),
  maidenName: yup.string(),
  addressLine1: yup.string(),
  addressLine2: yup.string(),
  addressLine3: yup.string(),
  city: yup.string(),
  state: yup.string(),
  postalCode: yup
    .string()
    .nullable()
    .test('is-valid-zip', 'Please enter a valid 5 digit zip code', (value) => {
      if (!value || value === '') return true
      return /^\d{5}$/.test(value)
    })
    .max(255, 'Must be at most 255 characters'),
  property_id: yup.string().required(),
  personalPhoneNumber: yup
    .string()
    .required('Please enter a personal phone number')
    .test(
      'is-valid-phone-number',
      'Please enter a valid personal phone number',
      (value) => {
        // The .required() check above does NOT ensures the field is not empty as it would have +1 as default value
        // We need to check for plus sign separately to allow empty values
        if (!value || value === '+' || value === '+1' || value === '') {
          return false
        }
        // Then validate the phone number format
        return isValidPhoneNumberFormat(value)
      },
    )
    .max(255, 'Must be at most 255 characters'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .required('Please enter an email address')
    .max(255, 'Must be at most 255 characters'),
  optInphone: yup.boolean(),
  optInMail: yup.boolean(),
  desiredMoveInDate: yup.date().required(),
  desired_unit_type: yup.string(),
  desired_unit: yup.string(),
  desiredRentMax: yup.string(),
  desiredNumBedrooms: yup.string(),
  desiredNumBathrooms: yup.string(),
  desiredLeaseTerms: yup.string().max(12),
  numberOfOccupants: yup.string(),
  comment: yup.string(),
})

export default createGuestCardSchema
